module.exports = __webpack_public_path__ + "be1a3053b3736e831c6990ac9355713b.svg";